import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const visaApplied = createAsyncThunk("visaApplied", async (data, { rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/visaApplied`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
});

const visaAppliedUpdateDeliveryDate = createAsyncThunk("visaAppliedUpdateDeliveryDate", async (data, { rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/visaAppliedUpdateDeliveryDate/${data.id}`,
        data,
        config
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
});

const getVisaApplied = createAsyncThunk("getVisaApplied", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/visaApplied/${data.id}`,
      {withCredentials: true}
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data.message);
  }
});

const getVisaAppliedList = createAsyncThunk("getVisaAppliedList", async (data, { rejectWithValue }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/visaAppliedList`,
      {withCredentials: true}
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data.message);
  }
});

export {visaApplied, getVisaApplied, getVisaAppliedList, visaAppliedUpdateDeliveryDate};